export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_39-6af8ac67be639d8dc111b42d9debeeac.jpg";